import { useState, useEffect } from 'react';
export default function DotNavigation({ sections }) {
    const [activeSection, setActiveSection] = useState(sections[0]);
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight / 2;
            for (const section of sections) {
                const element = document.getElementById(section);
                if (!element)
                    continue;
                const { top, bottom } = element.getBoundingClientRect();
                const elementTop = top + window.scrollY;
                const elementBottom = bottom + window.scrollY;
                if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
                    setActiveSection(section);
                    break;
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sections]);
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (<nav className='fixed right-8 top-1/2 -translate-y-1/2 z-50 hidden lg:block'>
      <ul className='space-y-4'>
        {sections.map((section) => (<li key={section}>
            <button onClick={() => scrollToSection(section)} className={`w-3 h-3 rounded-full transition-all
                ${activeSection === section
                ? 'bg-navy scale-125'
                : 'bg-navy/20 hover:bg-navy/40'}`} aria-label={`Scroll to ${section} section`}/>
          </li>))}
      </ul>
    </nav>);
}
